import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/patterns'
import { ModalCloseButton } from 'components/patterns/Modal'
import AlertIcon from 'components/patterns/Icon/components/Icon__Alert'
import strings from 'utils/strings'
import { displayModuleName } from 'i18n/displayConstants'
import {
  StyledModal,
  StyledHeader,
  StyledContentBody,
  StyledFooter,
} from './DynamicFeatureValidationModal.style'

const getMaxLogicCount = (item) => {
  const maxLogicCount = item.MaxLogicCount ?? item.maxLogicCount
  return typeof maxLogicCount === 'number' &&
    Number.isFinite(maxLogicCount) &&
    maxLogicCount > 0
    ? maxLogicCount
    : 40
}

const DynamicFeatureValidationModal = ({ data, serialNumber, onClose }) => (
  <StyledModal
    header={
      <StyledHeader>
        <span aria-hidden="true">
          <AlertIcon width={20} height={18} />
        </span>
        <h3>{strings.dynamic_feature_validation_dialog_title}</h3>
        <ModalCloseButton onClick={onClose} aria-label={strings.close} />
      </StyledHeader>
    }
    isOpen={data?.length > 0}
    noHandler={onClose}
    customFooter={
      <StyledFooter>
        <Button onClick={onClose} type="secondary">
          {strings.go_back}
        </Button>
      </StyledFooter>
    }
  >
    <StyledContentBody>
      {strings.dynamic_feature_validation_dialog_content({
        serialNumber,
        data: data.map((item) => ({
          ...item,
          maxLogicCount: getMaxLogicCount(item),
          moduleDisplayName: displayModuleName(item.module, item.module),
        })),
      })}
    </StyledContentBody>
  </StyledModal>
)

DynamicFeatureValidationModal.propTypes = {
  serialNumber: PropTypes.string,
  data: PropTypes.array,
  onClose: PropTypes.func,
}

DynamicFeatureValidationModal.defaultProps = {
  data: [],
}

export default DynamicFeatureValidationModal
